/**
* 头部菜单
*/
<template>
  <div class="nav-tem">
    <i v-if="collapsed"
      :class="'el-icon-s-unfold'"
      @click="toggle(collapsed)"
      style="margin-top:8px;margin-right: 10px; font-size: 25px"
    >
    </i>
    <i v-else
      :class="'el-icon-s-fold'"
      @click="toggle(collapsed)"
      style="margin-top:8px;margin-right: 10px; font-size: 25px"
    >
    </i>
    <el-form>
      <el-form-item>
        <el-select v-model="optionsname"  size="" @change="changeCom" :popper-append-to-body="false" class="hello">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <!-- <el-input placeholder="全部数据"></el-input> -->
      </el-form-item>
    </el-form>
    <el-menu
      class="el-menu-demo no-border"
      mode="horizontal"
      background-color="#fff"
      text-color="#0f215d"
      active-text-color="#fff"
    >
      <span class="nav-tem3">
        <el-avatar :src="this.getData1.avatar.substr(0,4) == 'http' ? this.getData1.avatar : $url.img + this.getData1.avatar"  :key="$url.img + this.getData1.avatar" v-if="this.getData1.avatar">

        </el-avatar>
        <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'" style="height: 40px;width:40px;border-radius: 50%" v-else></el-image>
      </span>
      <el-submenu index="1" class="submenu" popper-class="m-pop">

        <template slot="title">
          <!-- {{$url.img + mytaskbyid.avatar}} -->
         <!-- <el-image :src="$url.img + this.getData1.avatar" style="height: 40px;width:40px;border-radius: 50%" v-if="this.getData1.avatar"></el-image> -->

          <!-- {{$url.img + getData1.avatar}} -->
           <!-- <el-avatar :src="$url.img +avatar"></el-avatar> -->
         <span style="color:#141464">欢迎你，<span style="font-weight: 700">{{ user }}!</span></span>
        </template>
        <!-- <el-menu-item  @click="editPassword">修改密码</el-menu-item> -->
        <el-menu-item class="nav-tem1" @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
      <!--消息图标 -->
      <!-- <el-submenu index="2" class="submenu m-alert" >
        <template slot="title">
          <el-badge :value="messageNum" v-if="messageNum>0" class="item" >
            <img src="../assets/img/alert.png" alt="">
          </el-badge>
          <img src="../assets/img/alert.png" v-else alt="">
        </template>

        <el-menu-item v-if="messageNum>0">
          {{messageContent}}
        </el-menu-item>

        <el-menu-item v-else>
          暂无消息
        </el-menu-item>
      </el-submenu> -->
    </el-menu>

    <!-- <el-dialog title="修改密码" :visible.sync="formVisible">
      <el-form ref="formData" :model="formData" :rules="rules">
        <el-form-item prop="password" label="新密码" label-width="80px">
          <el-input
            placeholder="请输入新密码"
            v-model="formData.password"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>

      <p style="color: #e0231e; font-size: 12px">*输入新密码及更改密码</p>

      <div slot="footer" class="dialog-footer">
        <el-button
          class="btn-submit"
          type="primary"
          @click="submitForm('formData')"
          >确定</el-button
        >
        <el-button class="btn-cancel" @click="formVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import { loginOut, getMessage, updatePsw ,getadmin} from "../api/userMG";
import { getdepts2} from "../api/setting";

export default {
  name: "navcon",
  data() {
    return {
      //是否正在切换
      isactive:localStorage.setItem('isActive','1'),
      options: [],
      optionsname:parseInt(localStorage.getItem('dept_id')),
      // avatar:localStorage.getItem('avatar'),
      avatar:'',
      getData1:{
        avatar:''
      },
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: localStorage.getItem("name"),
      userId:localStorage.getItem("userId"),
      messageNum: 0,
      messageContent: "",
      formData: {
        password: "",
      },
      formVisible: false,
      rules: {
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.userId=this.$store.state.userId
    // this.user = this.$store.state.name
  },
  methods: {
    // editPassword() {
    //   this.formVisible = true;
    // },
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       let params = {
    //         id: localStorage.getItem("userId"),
    //         token: localStorage.getItem("token"),
    //         password: this.formData.password,
    //       };
    //       updatePsw(params).then((res) => {
    //         if (res.errno === 0) {
    //           this.$message({
    //             type: "success",
    //             message: res.data,
    //           });
    //           this.formVisible = false;
    //         } else {
    //           this.$message.error(res.data);
    //         }
    //       });
    //     }
    //   });
    // },
    // getMessageList() {
    //   getMessage().then((res) => {
    //     if (res.errno === 0) {
    //       this.messageNum = res.data.count;
    //       this.messageContent = res.data.message;
    //     }
    //   });
    // },
    getimg(){
      let params={
         token: localStorage.getItem("token"),
         id:this.userId
      };
      getadmin(params).then(res=>{
        if (res.errno === 0) {
           this.getData1=res.data
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.errno);
        }
      })
    },
    changeCom(){
      //当前选中的部门id存入本地
      localStorage.setItem('dept_id',this.optionsname)
      //切换id之后刷新页面
      location.reload();
    },
    getData(){
      let params={
        token: localStorage.getItem("token"),
        is_all:1
      }
      getdepts2(params).then(res=>{
         if (res.errno === 0) {
           this.options=res.data
           let item = {
             id:0,
             name:'全部数据'
           }
           this.options.push(item)
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      })
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      if(localStorage.getItem('isActive')=='1') {
        localStorage.setItem("isActive",'0')
        this.collapsed = !showtype;
        localStorage.setItem('collapse', this.collapsed)
        this.$root.Bus.$emit("toggle", this.collapsed);
      }else{
        this.$message.warning('请勿重复点击');
      }
    },
    getColl(){
      if(localStorage.getItem('collapse')=='true'){
        this.collapsed = true
      }else{
        this.collapsed = false
      }
    }
  },
  mounted() {
    this.getColl()
    this.getData()
    this.getimg()
  },
};
</script>
<style scoped>
  .nav-tem3{
    display: inline;
    margin-right: 5px;
    height: 50px;
    line-height: 50px;
  }
  .nav-tem3 >>> .el-avatar{
    margin: 5px 0;
  }
  .submenu >>> .el-avatar>img{
    display: inline-block;
  }
.nav-tem {
  display: flex;
  /* justify-content: space-between; */
  padding-left: 5px;
  height: 50px;
}
.nav-tem>>>.el-input__inner{
  width: 100px;
  border: none;
  text-align: center;
}
.nav-tem >>> .el-menu-demo {
  flex: 1;
  text-align: right;
  /* margin-top: 10px; */
  margin-right: 30px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.nav-tem >>>  input {
  background-color: #2b52e9;
  color: rgb(240, 234, 234);
}
.nav-tem1{
  text-align: center !important;
  color: #2b52e9!important;
  border-right: none;
}
.el-menu.el-menu--horizontal.no-border {
  height: 50px;
  border-bottom: none;
}
.m-alert {
  border-right: 2px solid #f9f8fd;
}
.nav-tem >>> .el-menu-demo.el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
}
.nav-tem
  >>> .el-menu-demo.el-menu--horizontal
  > .el-submenu
  .el-submenu__title {
  height: 50px;
  line-height: 50px;
}
.nav-tem >>> .el-input__inner{
  height: 50px;
  width: 110px;
  border-radius: unset;
}
.nav-tem >>> .el-badge__content.is-fixed {
  top: 16px;
  right: 10px;
}
.nav-tem >>> .el-badge__content {
  height: 12px;
  line-height: 12px;
  background-color: #e0231e;

}
.nav-tem >>> i{
  color: #2b52e9;
}
.el-menu-demo>>>.el-submenu__title{
  padding: 0px 0px;
}
.nav-tem1 >>>.el-submenu__title{
  padding-left: 30px !important;
}
</style>
<style>
.m-pop .el-menu--popup {
  min-width: 168px !important;
  text-align: center !important;
  padding: 0;
}
.m-pop.el-menu--horizontal .el-menu-item:not(last-child) {
  text-align: center !important;
  /* width: 168px !important; */
  /* background-color: #f31010 !important; */
  border-bottom: 1px solid #409EFF;
}
.m-pop.el-menu--horizontal .el-menu-item:last-child {
  border-bottom: 1px solid transparent;
}
.m-pop.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: #fbfbfb !important;
  color: rgb(128, 128, 128) !important;
}
.m-alert .el-submenu__icon-arrow.el-icon-arrow-down {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/navcon.vue